document.addEventListener('DOMContentLoaded', () => {
    const popup = document.getElementById('popup');
    const closeBtn = document.querySelector('.close-btn');
    const botonesSoluciones = document.querySelectorAll('.btn_soluciones');

    let scrollY = 0;

    if (!popup || !closeBtn) return;

    botonesSoluciones.forEach((botonPop) => {
        botonPop.addEventListener('click', (e) => {
            e.preventDefault();

            const nuevoTitulo = botonPop.getAttribute('data-title');
            const tituloElement = document.getElementById('popup-title');
            if (tituloElement) {
                tituloElement.textContent = nuevoTitulo;
            }

            const itemsContainer = document.getElementById('popup-items-container');
            if (itemsContainer) {
                itemsContainer.innerHTML = ''; // limpiamos

                const itemsJSON = botonPop.getAttribute('data-items');
                if (itemsJSON) {
                    try {
                        const items = JSON.parse(itemsJSON);

                        items.forEach((item) => {
                            const div = document.createElement('div');
                            div.className = 'container_popup_items';
                            div.innerHTML = `
                            <div class="container_popup_items-figure">
                                <img class="container_popup_items-img" 
                                     src="${item.url}" 
                                     alt="${item.alt || item.text}" />
                            </div>
                            <p class="container_popup_items-text">${item.text}</p>
                        `;
                            itemsContainer.appendChild(div);
                        });
                    } catch (error) {
                        console.error('Error parsing data-items JSON', error);
                        itemsContainer.innerHTML = '<p>Error cargando contenido</p>';
                    }
                }
            }
            // ===============================================

            popup.classList.remove('ocultarPop');
            popup.classList.add('ver');
            bloquearScroll();
        });
    });

    closeBtn.addEventListener('click', ocultarPopup);

    popup.addEventListener('click', (e) => {
        if (e.target === popup) ocultarPopup();
    });

    // Fix: Permitir scroll interno en popup-content aunque el body esté bloqueado
    const popupContent = document.querySelector('.popup-content');
    if (popupContent) {
        popupContent.addEventListener(
            'wheel',
            function (e) {
                e.stopPropagation();
            },
            { passive: false }
        );
    }

    // Cerrar popup con tecla Escape
    document.addEventListener('keydown', function (e) {
        if (popup.classList.contains('ver') && e.key === 'Escape') {
            ocultarPopup();
        }
    });

    function ocultarPopup() {
        popup.classList.remove('ver');
        setTimeout(() => {
            popup.classList.add('ocultarPop');
            permitirScroll();
        }, 300);
    }

    let scrollBloqueado = false;

    function bloquearScroll() {
        scrollY = window.scrollY;
        scrollBloqueado = true;
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.body.style.paddingRight = `${scrollbarWidth}px`;
    }

    function permitirScroll() {
        scrollBloqueado = false;
        const scrollPosition = scrollY;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        document.body.style.paddingRight = '';
        window.scrollTo(0, scrollPosition);
    }
});

function animateOnScroll() {
    const elements = document.querySelectorAll('.fade-up');

    elements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (rect.top < windowHeight - 50) {
            // se activa 50px antes de entrar
            el.classList.add('show');
        }
    });
}

window.addEventListener('scroll', animateOnScroll);
window.addEventListener('load', animateOnScroll);
